import React from 'react';
import {Container, HeaderInfo, UsersContainer} from "./users.styles";

const Users = ({children, title, userSecAction: ActionButton}) => {

    return (
        <Container className='d-flex flex-column align-items-center'>
            <HeaderInfo className='d-flex align-items-center justify-content-between lng-dir'>
                <p className='lng-text mb-0'>{title}</p>
                {
                    ActionButton &&
                    <ActionButton/>
                }
            </HeaderInfo>
            <UsersContainer>
                {children}
            </UsersContainer>
        </Container>
    );
};

export default Users;
